import { render, staticRenderFns } from "./performance-calculation-rules.vue?vue&type=template&id=25c0edba&scoped=true"
import script from "./performance-calculation-rules.vue?vue&type=script&lang=js"
export * from "./performance-calculation-rules.vue?vue&type=script&lang=js"
import style0 from "./performance-calculation-rules.vue?vue&type=style&index=0&id=25c0edba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c0edba",
  null
  
)

export default component.exports